import { Box, Card, Checkbox, CircularProgress, Table, TableCell, TableRow, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import LinkIcon from "@mui/icons-material/Link";
import { useMessages } from "./MessagesContext";

const isActiveMessage=(message)=>{
    if(message.expirationDate === null || new Date(message.expirationDate) >new Date()){
        // console.log("Expiry check-->"+message.id+":"+message.expirationDate)
        return true
    }
    else    
        return false
}

const MessagesList =()=>{
     const { messages, setSelectedMessage, setSelectedMessageLog } =
        useMessages();
    if(messages!= null && messages.length > 0){
        
        return (
            <Card>
                <Table size='small'>
                    <TableRow className="report-header">
                        <TableCell> ID </TableCell>
                        <TableCell> Text </TableCell>
                        <TableCell> Priority </TableCell>
                        <TableCell> Active </TableCell>
                        <TableCell> Expiration Date </TableCell>
                        <TableCell> Logs </TableCell>
                        
                    </TableRow>
        {(messages.map((eachMessage, idx)=>{
            console.log("allMessages"+JSON.stringify(messages))
            const isExpired = isActiveMessage(eachMessage);
            return (            
                <TableRow className={idx % 2 === 0 ? "styledtablerow" : ""}>
                    <TableCell>
                    <Link  className="hyper-links" onClick={(e)=>{setSelectedMessage(eachMessage)}}>
                    {eachMessage.id}
                    </Link>
                    </TableCell>
                    <TableCell  align='left' >
                    {/* <Link  className="hyper-links" onClick={(e)=>handleAnnouncement(eachAnnouncement.id,setOpenDispAnnouncement)}> */}
                      <span dangerouslySetInnerHTML={{ __html: eachMessage.text}}></span>
                    {/* </Link> */}
                    </TableCell>
                    
                    <TableCell>
                        {eachMessage.priority}
                    </TableCell>

                    <TableCell>
                        <Checkbox disabled checked={isExpired}></Checkbox>
                    </TableCell>
                    
                    {/* <TableCell>
                        <a href="{eachAnnouncement.link}" target="_blank" rel="noopener noreferrer" className="hyper-links" > {eachAnnouncement.link} </a>
                    </TableCell> */}
                    <TableCell>
                        {eachMessage.expirationDate}
                    </TableCell>
                    
                    <TableCell>
                        <Link
                        style={{ textDecoration: "none" }}
                        className="hyper-links"
                        onClick={(e) => {
                            setSelectedMessageLog(eachMessage);
                        }}
                        >
                        {/* AnnouncementLogs */}
                        <LinkIcon fontSize="medium"  />
                        </Link>
                
                    </TableCell>
                    
                </TableRow>
            )
        }))}
        </Table> 
        </Card>
            )
        
        } 
        else 
            return (<Box sx={{ width: "100%", textAlign: "center" }}>
            {/* <Typography variant="h6">No Data Found</Typography> */}
            <CircularProgress/>
         </Box>)
    }  
    
    export default MessagesList;
        
        